import { useCallback } from 'react';
import { useBrandCreateMutation } from 'api';
import { Form, FormProps, notification } from 'components';
import { ErrorMappingValueType } from 'typings';
import { BrandAddFormFieldType } from 'typings/form/brand';

export const useAddBrand = (props: { onModalStateChange: () => void }) => {
  const [form] = Form.useForm();
  const { onModalStateChange } = props;
  const [createBrand, { isLoading }] = useBrandCreateMutation();
  const [notificationApi, contextHolder] = notification.useNotification();

  const triggerNotification = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message });
    },
    [notificationApi]
  );

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish: FormProps<BrandAddFormFieldType>['onFinish'] = useCallback(
    async (values: BrandAddFormFieldType) => {
      try {
        const { data, error }: any = await createBrand(values);
        if (data?.success) {
          triggerNotification({ type: 'success', message: 'The brand was successfully created.' });
          onModalStateChange();
          form.resetFields();
        } else if (error?.data) {
          const { data: errorData } = error.data;
          if (errorData) {
            Object.keys(errorData).forEach((key) => {
              triggerNotification({ type: 'error', message: errorData[key] });
            });
          } else {
            triggerNotification({ type: 'error', message: error.data?.error || 'Something went wrong!' });
          }
        }
      } catch (err) {
        console.log(err, 'error');
        triggerNotification({ type: 'error', message: 'Something went wrong!' });
      }
    },
    [createBrand, triggerNotification, form, onModalStateChange]
  );

  return {
    form,
    onCancel,
    onFinish,
    contextHolder,
    isLoading,
  };
};
